import _ from 'lodash'
import { Component } from 'react'
import { connect } from 'react-redux'

import { withDiscardDialog } from '../../lib/global-discard-dialog'
import { phoneToFhir } from '../../lib/Proxy/lib/phone'
import { Warning } from '../igao/components/warnings/warning'
import { PlainButton } from '../shared/Button'
import { bindTargetMixin } from '../shared/FormBuilder'
import { CircularProgress } from '../shared/NarusMaterial'

import actions from './actions'
import { renderPersonalInformation, renderNotifications, renderPreference } from './shared'

const prepareValue = profile =>
  profile && {
    ...profile,
    phone: _.chain(profile).get('phone', '').split('+1').last()
      .value(),
    contact: _.chain(profile).get('contact', '').split('+1').last()
      .value(),
    on_patient_folder_open: profile.on_patient_folder_open ?? 'null',
    on_encounter_open: profile.on_encounter_open ?? 'null'
  }

const prepareProfile = value =>
  value && {
    ...value,
    phone: value.phone && `+1${phoneToFhir(value.phone)}`,
    contact: value.contact && `+1${phoneToFhir(value.contact)}`,
    onduty: value.onduty ?? false,
    monitoring: value.monitoring ?? false,
    oncall: value.oncall ?? false,
    concierge: value.concierge ?? false,
    practitioner_notifications: value.practitioner_notifications ?? false,
    on_patient_folder_open: value.on_patient_folder_open === 'null' ? null : value.on_patient_folder_open ?? null,
    on_encounter_open: value.on_encounter_open === 'null' ? null : value.on_encounter_open ?? null
  }

@withDiscardDialog
class ProfileForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: props.value,
      initialData: props.value
    }

    this.onSave = this.onSave.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  get canSave () {
    return (
      !_.isEqual(this.state.value, this.state.initialData) &&
      this.isValid()
    )
  }

  get canCancel () {
    return !_.isEqual(this.state.value, this.state.initialData)
  }

  onCancel () {
    this.props.discardDialog.show(this.props.formKey, this.props.onCancel)
  }

  onSave () {
    this.props.onSave(this.state.value)
    this.props.discardDialog.resetForm(this.props.formKey)
  }

  render () {
    return (
      <form style={{ padding: '0 10px' }}>
        <h2
          className='setting-header'
        >
          Personal Info
        </h2>
        {renderPersonalInformation(true)}
        <h2
          className='setting-header'
          style={{ marginTop: '40px' }}
        >
          Notifications
        </h2>
        {renderNotifications(this.props.role)}

        <h2
          className='setting-header'
          style={{ marginTop: '40px' }}
        >
          Preferences
        </h2>
        {renderPreference()}

        <div
          className='row'
          style={{
            marginBottom: '25px',
            marginTop: '35px',
            marginLeft: '10px'
          }}
        >
          <Warning
            type='concurrent'
            title='You will need to log out and log in again to apply changes'
          />
        </div>

        <div
          className='row end-xs margin-top'
          style={{ marginBottom: '70px' }}
        >
          <div className='col-xs-offset-8 col-xs-4'>
            <PlainButton
              disabled={!this.canCancel}
              style={{ margin: '0 6px' }}
              label='Cancel'
              btnType='contained'
              onClick={this.onCancel}
            />
            <PlainButton
              disabled={!this.canSave}
              color='primary'
              type='contained'
              label='Save'
              onClick={this.onSave}
            />
          </div>
        </div>
      </form>
    )
  }
}

function mapStateToProps (state) {
  return {
    profile: state?.profile ?? {},
    role: _.get(state, 'auth.profile.app_metadata.roles.meta.role')
  }
}

@connect(mapStateToProps)
export default class Profile extends Component {
  UNSAFE_componentWillMount () {
    const { dispatch } = this.props
    dispatch(actions.get())
  }

  render () {
    const { profile, dispatch, role } = this.props
    return (
      <div
        className='wrapper'
        style={{ marginTop: '40px' }}
      >
        <div className='assessment'>
          <div className='assessment-body'>
            {profile.loading
              ? (
                <CircularProgress />
              )
              : (
                <ProfileForm
                  formKey='profile'
                  value={prepareValue(profile.profile)}
                  onSave={value => {
                    dispatch(actions.set(prepareProfile(value)))
                  }}
                  onCancel={() => {
                    dispatch(actions.get())
                  }}
                  role={role}
                />
              )}
          </div>
        </div>
      </div>
    )
  }
}
